"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
function ContentContainer(props) {
    var fullWidth = props.fullWidth, children = props.children, contentClassName = props.className, halfPin = props.halfPin, pinAfterScrollingPx = props.pinAfterScrollingPx, pinOrder = props.pinOrder, isMain = props.isMain, domPropsRest = __rest(props, ["fullWidth", "children", "className", "halfPin", "pinAfterScrollingPx", "pinOrder", "isMain"]);
    var contentContainerClasses = classNames("l-content-container", fullWidth && " l-content-container-full-width", halfPin && "half-pin");
    var combinedClasses = contentClassName
        ? contentClassName + " " + contentContainerClasses
        : contentContainerClasses;
    return (React.createElement("section", __assign({ className: combinedClasses }, (pinAfterScrollingPx && { 'data-pin-on-scroll': pinAfterScrollingPx }), (pinOrder && { 'data-pin-on-scroll-order': pinOrder }), (isMain !== false && { role: 'main' }), domPropsRest), children));
}
exports.ContentContainer = ContentContainer;
